export class IdelinkGlobalConstants {
	public static CLIENT_SECRET = 'Ideine';

	//* Clé GMAP Web pour Idelink local (via .env.development.local, généré par npm run fetch-secrets)
	public static GOOGLE_MAP_API_KEY_DEVELOPMENT = import.meta.env.VITE_GOOGLE_MAP_API_KEY ?? '';

	public static LOGS = {
		clientId: 'default',
		code: 'fIU59n4QGM0OE7UVfQQLrVkwgmygDragYTGLZR1CqVetA6bPSj0Gnw==',
		domain: 'https://idelink-functions-app.azurewebsites.net',
		uri: '/api/IdelinkMobileAnalytics',
	};
}
